import { render, staticRenderFns } from "./matches.vue?vue&type=template&id=0ed77cba&"
import script from "./matches.vue?vue&type=script&lang=js&"
export * from "./matches.vue?vue&type=script&lang=js&"
import style0 from "./matches.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports